// extracted by mini-css-extract-plugin
export default {"showAllComment":"index_showAllComment_1Kb-Y"};